import { useState } from "react";
import route from "ziggy-js";
import Img from "app/components/Image";

interface CardProps {
    title?: string;
    subtitle?: string;
    description?: string;
    logoDefault?: string;
    logoHover?: string;
    newOneLogoDefault?: string;
    newOneLogoHover?: string;
    backgroundImg?: string;
    link?: string;
    showDescription?: boolean;
}

function CateringCard({
    title,
    subtitle,
    description,
    logoDefault,
    logoHover,
    newOneLogoDefault,
    newOneLogoHover,
    backgroundImg,
    link,
    showDescription = false,
}: CardProps) {
    const [hover, setHover] = useState(false);

    return (

        <a
            href={link || "#"}
            className="relative mb-48px mob:mb-16px flex-1 cursor-pointer overflow-hidden group"
            style={{
                backgroundImage: `url(${backgroundImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            {/* Překryv */}
            <div className="absolute inset-0 bg-black bg-opacity-60 transition-opacity duration-300 group-hover:bg-opacity-70" />
            <div className="absolute top-[20px] right-[20px] z-20">
                <Img
                    src={`/assets/img/catering/Arrow.svg`}
                    alt="New One logo"
                    className={`object-contain transition-all duration-[300ms] ease-in-out ${hover ? 'opacity-80 scale-125' : ''}`}
                    layout="fill"
                />
            </div>
            {/* Text a logo */}
            <div className="p-0 absolute mb:mb-0 px-0 md:px-48px  mob:h-[340px] mob:relative bottom-0 z-10 pl-[56px] mob:pl-[24px]  flex flex-col pb-[56px] justify-end  text-white">
                <div
                    className="flex flex-col transition-transform duration-[300ms] ease-in-out"
                    style={{ transform: hover ? 'translateY(-20px)' : 'translateY(0)' }}
                >
                    <div className="text-[18px] font-normal flex items-center leading-[24px]">{subtitle}</div>
                    <h2 className="text-[18px] font-normal flex items-center leading-[24px] relative">
                        <span className="text-[18px] font-normal leading-[24px]">{title}</span>
                        <div className="relative mob:w-1/2">
                            <Img
                                src={hover ? newOneLogoHover : newOneLogoDefault}
                                alt="New One logo"
                                className="object-contain"
                                layout="fill"
                            />
                        </div>
                    </h2>
                </div>

                {showDescription && (
                    <p
                        className="text-[18px] font-normal leading-[24px] w-full transition-all duration-300 ease-in-out"
                        style={{
                            opacity: hover ? 1 : 0,
                            maxHeight: hover ? "200px" : "0",
                            overflow: "hidden",
                        }}
                    >
                        {description}
                    </p>
                )}
            </div>


            {/* Šipka vpravo nahoře */}
        </a>

    );
}

export default function CateringShowcase() {
    return (
        <div className="flex w-full  h-[447px]  mob:relative mob:flex mob:flex-col mob:h-full">
            <CateringCard
                title=""
                subtitle="Novinka"
                description="Na míru pro firemní i soukromé akce, vždy s důrazem na čerstvé suroviny, styl a spolehlivost."
                logoDefault="/assets/img/catering/catering_new_one_logo.svg"
                logoHover="/assets/img/catering/catering_big_logo.png"
                newOneLogoDefault="/assets/img/catering/cat_new_logo.svg"
                newOneLogoHover="/assets/img/catering/cat_new_logo.svg"
                backgroundImg="/assets/img/catering/catering_image.png"
                link={route('catering', {}, true)}
                showDescription={true}
            />
            {/* <CateringCard
                title=""
                subtitle="Novinka"
                description="Ať už slavíte narozeniny, zásnuby, svatbu, výročí, úspěch v práci, promoci, příchod nového člena rodiny nebo jen chvíli, na kterou chcete vzpomínat — naše dorty dodají každému výjimečnému okamžiku sladkou atmosféru a chuť, která zůstane v paměti."
                logoDefault="/assets/img/catering/cat_logo2.svg"
                logoHover="/assets/img/catering/logo_cake_hover.png"
                newOneLogoDefault="/assets/img/catering/pink_cafe_logo.svg"
                newOneLogoHover="/assets/img/catering/pink_cafe_logo.svg"
                backgroundImg="/assets/img/catering/cake_img.png"
                link={route('cake', {}, true)}
                showDescription={true}
            /> */}
        </div>
    );
}